<template>
  <div>
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="red" class="ms-2">mdi-delete</v-icon>
      </template>
      <v-card class="pa-6">
        <v-card-text class="subtitle-1 mb-0 mt-6 text-center dark--text">Do you really want to delete this promo code?</v-card-text>

        <v-card-text v-if="error" class="error--text font-weight-bold">{{ error }}</v-card-text>
        <v-card-actions justify="center">
          <v-row justify="center">
            <v-btn color=" mx-2 error" depressed @click="close">No</v-btn>
            <v-btn color=" mx-2 success" depressed @click="deletePromoCode(promoCode._id)">Yes</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </div>
</template>
<script>
export default {
  props: {
    promoCode: {
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      dialog: false,
      show_alert: false,
      error: null,
      snackbar: false,
      text: "",
    };
  },
  methods: {
    deletePromoCode(id) {
      this.$apollo
        .mutate({
          mutation: require("../api/deletePromoCode.graphql"),
          variables: {
            id: id,
          },
        })
        .then(() => {
          this.$root.$emit("updatePromoCode");
          this.error = null;
          this.dialog = false;
          this.snackbar = true;
          this.text = "Promo Code deleted";
        })
        .catch(error => {
          // Error
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
        });
    },
    close() {
      this.error = null;
      this.dialog = false;
    },
  },
};
</script>
